export default {
  //授课测试
  SKTestList: '',
  //测试详情
  SKTestDetails: '',
  //测试结束
  SKTestEnd: '',
  //测试推送
  SKTestEdit: '',
}
